export default "__VITE_ASSET__DsAf4uLs__"